import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { SiteState } from '../store/site-reducer'
import useMobile from '../hooks/useMobile'
import DesktopNav from './desktop-nav'
import MobileNav from './mobile-nav'
import useOnboarding from '../hooks/useOnboarding'

export default function Navigation(props: any): React.ReactElement {
  const mobile = useMobile()
  const { selected } = useSelector(({ site }: { site: SiteState }) => site)

  const inSetup =
    selected && (selected.preSetup || selected.billingState === 'preSetup')
  const { skeleton, showWelcome } = props
  // When inSetup is null, that's when we are on temp token
  const skel = inSetup === null ? true : skeleton

  const { fullOnboardingSections } = useOnboarding()

  const onboardingNotifications = useMemo(() => {
    if (fullOnboardingSections && fullOnboardingSections.length > 0) {
      const incomplete = fullOnboardingSections.reduce((acc, curr) => {
        if (
          (curr.sectionCompleted &&
            (curr.sectionSkipped || !curr.sectionSkippedBefore)) ||
          curr.sectionSkipped
        ) {
          return acc
        }
        return acc + 1
      }, 0)
      return incomplete
    }
    return 0
  }, [fullOnboardingSections])

  if (mobile) {
    return (
      <MobileNav
        {...props}
        inSetup={inSetup}
        skeleton={skel}
        showWelcome={showWelcome}
        onboardingNotifications={onboardingNotifications}
      />
    )
  }

  return (
    <DesktopNav
      {...props}
      inSetup={inSetup}
      skeleton={skel}
      showWelcome={showWelcome}
      onboardingNotifications={onboardingNotifications}
    />
  )
}
